//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { DepartmentAlreadyExistsMessage } from './department-already-exists.message';

@PresenterType(
{
    model: DepartmentAlreadyExistsMessage
})
@Component({
    selector: 'department-already-exists-message-template',
    templateUrl: './department-already-exists-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DepartmentAlreadyExistsMessageTemplateComponent
{
    public data: WritableSignal<DepartmentAlreadyExistsMessage>;
    
    constructor() {
        this.data = signal<DepartmentAlreadyExistsMessage>(null);
    }
}